import { dashboardTypes } from '../reduxExports';

const dashboardInitialState: DashboardState = {
  dashboardHeaderData: null,
  alarmSummaryData: null,
  alarmSummaryDataNextToken: null,
  customerWiseChargerHealthData: null,
  customerWiseChargerHealthDataNextToken: null,
  chargerHealthData: null,
  chargerHealthGraphLoader: false,
  dashboardHeaderLoader: false,
  alarmSummaryCountLoader: false,
  alarmSummaryTableLoader: false,
  customerWiseChargerHealthGraphLoader: false,
  connectivityMediumData: null,
  newDashboardHeaderData: null,
  newDashboardRealTimeGunsInfo: null,
  newDashboardConnectivityMediumData: null,
  newDashboardActiveAlarmsInfo: null,
  newDashboardAlarmSeverityInfo: null,
  newDashboardAlarmOutliersList: null,
  newDashboardFailedTransactionList: null,
  newDashboardFailedTransactionTopReasons: null,
  newDashboardAlarmClearInfo: null,
  newDashboardAIInsights: null,
  newDashboardChargingSessionsInfo: null,
  newDashboardChargingSessionsStats: null,
  newDashboardChargingSessionTrendInfo: null,
  newDashboardChargingVsIdleInfo: null,
  newDashboardEnergyTrendInfo: null,
  newDashboardOverallUptimeInfo: null,
  newDashboardAlarmSummaryInfo: null,
  newDashboardAlarmSummaryFilterHash: null,
  newDashboardAlarmSummaryTableLoader: false,
  newDashboardFailedTransactionListFilterHash: null,
  newDashboardFailedTransactionTopReasonsFilterHash: null,
  newDashboardAttentionRequiredInfo: null,
  newDashboardAttentionRequiredFilterHash: null,
  newDashboardUptimeFilterHash: null,
  newDashboardEnergyTrendFilterHash: null,
  newDashboardChargingVsIdleFilterHash: null,
  newDashboardCharginsSessionTrendFilterHash: null,
  newDashboardChargingSessionFilterHash: null,
  newDashboardInsightsFilterHash: null,
  newDashboardRealtimeGunInfoFilterHash: null,
  newDashboardHeaderFilterHsah: null,
  newDashboardConnectivityFilterHash: null,
  newDashboardEfficiencyTrendInfo:null,
  newDashboardEfficiencyTrendFilterHash: null,
  newDashboardCustomerAverageEfficiency:null,
  newDashboardReactiveEnergyConsumptionTrendInfo:null,
  newDashboardReactiveEnergyConsumptionTrendFilterHash:null,
  newDashboardCustomerAverageReactiveEnergyConsumption:null,
};

const dashboardReducer = (
  state: DashboardState = dashboardInitialState,
  action: DashboardAction
): DashboardState => {
  switch (action.type) {
    case dashboardTypes.FETCH_DASHBOARD_HEADER_DATA:
      return {
        ...state,
        dashboardHeaderData: action.dashboardHeaderData,
      };
    case dashboardTypes.FETCH_ALARM_SUMMARY_DATA:
      return {
        ...state,
        alarmSummaryData: action.alarmSummaryData,
        alarmSummaryDataNextToken: action.alarmSummaryDataNextToken,
      };
    case dashboardTypes.FETCH_CUSTOMER_HEALTH_DATA:
      return {
        ...state,
        customerWiseChargerHealthData: action.customerWiseChargerHealthData,
        customerWiseChargerHealthDataNextToken: action.customerWiseChargerHealthDataNextToken,
      };
    case dashboardTypes.FETCH_CHARGER_HEALTH_DATA:
      return {
        ...state,
        chargerHealthData: action.chargerHealthData,
      };
    case dashboardTypes.FETCH_CONNECTIVITY_MEDIUM_DATA:
      return {
        ...state,
        connectivityMediumData: action.connectivityMediumData,
      };
    case dashboardTypes.CLEAR_DASHBOARD_STATE_DATA:
      return {
        ...state,
        dashboardHeaderData: null,
        alarmSummaryData: null,
        alarmSummaryDataNextToken: null,
        customerWiseChargerHealthData: null,
        customerWiseChargerHealthDataNextToken: null,
        chargerHealthData: null,
        chargerHealthGraphLoader: false,
        dashboardHeaderLoader: false,
        alarmSummaryCountLoader: false,
        alarmSummaryTableLoader: false,
        customerWiseChargerHealthGraphLoader: false,
        connectivityMediumData: null,
        
      };
    case dashboardTypes.SET_DASHBOARD_STATE_DATA:
      return { 
        ...state,
        ...action
      } 
    case dashboardTypes.CLEAR_NEW_DASHBOARD_DATA: 
      return {
        ...state,
        newDashboardActiveAlarmsInfo: null,
        newDashboardAIInsights: null,
        newDashboardAlarmClearInfo: null,
        newDashboardAlarmOutliersList: null,
        newDashboardAlarmSeverityInfo: null,
        newDashboardChargingSessionsInfo: null,
        newDashboardChargingSessionTrendInfo: null,
        newDashboardChargingVsIdleInfo: null,
        newDashboardConnectivityMediumData: null,
        newDashboardFailedTransactionList: null,
        newDashboardFailedTransactionTopReasons: null,
        newDashboardHeaderData: null,
        newDashboardRealTimeGunsInfo: null,
      }
    case dashboardTypes.FETCH_NEW_DASHBOARD_HEADER_DATA:
      return {
        ...state,
        newDashboardHeaderData: action.newDashboardHeaderData,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_REAL_TIME_GUN_INFO:
      return {
        ...state,
        newDashboardRealTimeGunsInfo: action.newDashboardRealTimeGunsInfo,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_DATA:
      return {
        ...state,
        newDashboardConnectivityMediumData: action.newDashboardConnectivityMediumData,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_SEVERITY_INFO:
      return {
        ...state,
        newDashboardAlarmSeverityInfo: action.newDashboardAlarmSeverityInfo,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_ACTIVE_ALARM_INFO:
      return {
        ...state,
        newDashboardActiveAlarmsInfo: action.newDashboardActiveAlarmsInfo,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_OUTLIERS_LIST:
      return {
        ...state,
        newDashboardAlarmOutliersList: action.newDashboardAlarmOutliersList,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_LIST:
      return {
        ...state,
        newDashboardFailedTransactionList: action.newDashboardFailedTransactionList,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_FAILED_TRANSACTION_TOP_REASONS:
      return {
        ...state,
        newDashboardFailedTransactionTopReasons: action.newDashboardFailedTransactionTopReasons,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_CLEAR_TIME_INFO:
      return {
        ...state,
        newDashboardAlarmClearInfo: action.newDashboardAlarmClearInfo,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_AI_INSIGHTS_LIST:
      return {
        ...state,
        newDashboardAIInsights: action.newDashboardAIInsights,
      };
    case dashboardTypes.FETCH_NEW_CHARGING_SESSIONS_INFO:
      return {
        ...state,
        newDashboardChargingSessionsInfo: action.newDashboardChargingSessionsInfo,
        newDashboardChargingSessionsStats: action.newDashboardChargingSessionsStats,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_CHARGING_SESSION_TRENDS_INFO:
      return {
        ...state,
        newDashboardChargingSessionTrendInfo: action.newDashboardChargingSessionTrendInfo,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_CHARGING_VS_IDLE_INFO:
      return {
        ...state,
        newDashboardChargingVsIdleInfo: action.newDashboardChargingVsIdleInfo,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_ENERGY_TREND_INFO:
      return {
        ...state,
        newDashboardEnergyTrendInfo: action.newDashboardEnergyTrendInfo,
      };
    case dashboardTypes.FETCH_NEW_DASHBOARD_OVERALL_UPTIME_INFO:
      return {
        ...state,
        newDashboardOverallUptimeInfo: action.newDashboardOverallUptimeInfo,
      };
      case dashboardTypes.FETCH_NEW_DASHBOARD_ATTENTION_REQUIRED_DATA:
        return {
          ...state,
          newDashboardAttentionRequiredInfo: action.newDashboardAttentionRequiredInfo,
        };
    case dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_SUMMARY_LIST:
      return {
        ...state,
        newDashboardAlarmSummaryInfo: action.newDashboardAlarmSummaryInfo,
      }
    case dashboardTypes.SET_NEW_DASHBOARD_ALARM_SUMMARY_FILTER_HASH:
      return {
        ...state,
        newDashboardAlarmSummaryFilterHash: action.newDashboardAlarmSummaryFilterHash,
      }
    case dashboardTypes.FETCH_NEW_DASHBOARD_ALARM_SUMMARY_TABLE_LOADER:
      return {
        ...state,
        newDashboardAlarmSummaryTableLoader: action.newDashboardAlarmSummaryTableLoader,
      }
    case dashboardTypes.SET_NEW_DASHBOARD_FAILED_TRANSACTION_LIST_FILTER_HASH:
      return {
        ...state,
        newDashboardFailedTransactionListFilterHash: action.newDashboardFailedTransactionListFilterHash,
      }
    case dashboardTypes.SET_NEW_DASHBOARD_FAILED_TRANSACTION_TOP_REASONS_FILTER_HASH:
      return {
        ...state,
        newDashboardFailedTransactionTopReasonsFilterHash: action.newDashboardFailedTransactionTopReasonsFilterHash,
      }
    case dashboardTypes.SET_ATTENTION_REQUIRED_FILTER_HASH:
      return {
        ...state,
        newDashboardAttentionRequiredFilterHash: action.newDashboardAttentionRequiredFilterHash
      }
    case dashboardTypes.SET_NEW_DASHBOARD_UPTIME_FILTER_HASH:
      return {
        ...state,
        newDashboardUptimeFilterHash: action.newDashboardUptimeFilterHash
      }
    case dashboardTypes.SET_NEW_DASHDOARD_ENERGY_TREND_FILTER_HASH:
      return {
        ...state,
        newDashboardEnergyTrendFilterHash: action.newDashboardEnergyTrendFilterHash
      }
    case dashboardTypes.SET_DASHBOARD_CHARGING_VS_IDLE_FILTER_HASH:
      return {
        ...state,
        newDashboardChargingVsIdleFilterHash: action.newDashboardChargingVsIdleFilterHash
      }
    case dashboardTypes.SET_CHARGING_SESSION_TREND_FILTER_HASH: 
      return {
        ...state,
        newDashboardCharginsSessionTrendFilterHash: action.newDashboardCharginsSessionTrendFilterHash
      }
    case dashboardTypes.SET_NEW_DASHBOARD_CHARGING_SESSION_FILTER_HASH:
      return {
        ...state,
        newDashboardChargingSessionFilterHash: action.newDashboardChargingSessionFilterHash
      }
    case dashboardTypes.SET_NEW_DASHBOARD_INSIGHTS_FILTER_HASH: 
      return {
        ...state,
        newDashboardInsightsFilterHash: action.newDashboardInsightsFilterHash
      }
    case dashboardTypes.SET_NEW_DASHBOARD_REALTIME_GUN_INFO_FILTER_HASH:
      return {
        ...state,
        newDashboardRealtimeGunInfoFilterHash: action.newDashboardRealtimeGunInfoFilterHash
      }
    case dashboardTypes.SET_NEW_DASHBOARD_HEADER_FILTER_HASH: 
      return {
        ...state,
        newDashboardHeaderFilterHsah: action.newDashboardHeaderFilterHsah
      }
    case dashboardTypes.SET_NEW_DASHBOARD_CONNECTIVITY_MEDIUM_FILTER_HASH: 
      return {
        ...state,
        newDashboardConnectivityFilterHash: action.newDashboardConnectivityFilterHash
      }
      case dashboardTypes.FETCH_NEW_DASHBOARD_EFFICIENCY_TREND_INFO:
      return {
        ...state,
        newDashboardEfficiencyTrendInfo: action.newDashboardEfficiencyTrendInfo,
        newDashboardCustomerAverageEfficiency: action.newDashboardCustomerAverageEfficiency
      };
     case dashboardTypes.SET_NEW_DASHDOARD_EFFICIENCY_TREND_FILTER_HASH:
      return {
        ...state,
        newDashboardEfficiencyTrendFilterHash: action.newDashboardEfficiencyTrendFilterHash
      }
      case dashboardTypes.FETCH_NEW_DASHBOARD_REACTIVE_ENERGY_CONSUMPTION_TREND_INFO :
      return {
        ...state,
        newDashboardReactiveEnergyConsumptionTrendInfo: action.newDashboardReactiveEnergyConsumptionTrendInfo,
        newDashboardCustomerAverageReactiveEnergyConsumption:action.newDashboardCustomerAverageReactiveEnergyConsumption
      };
     case dashboardTypes.SET_NEW_DASHDOARD_REACTIVE_ENERGY_CONSUMPTION_TREND_FILTER_HASH:
      return {
        ...state,
        newDashboardReactiveEnergyConsumptionTrendFilterHash: action.newDashboardReactiveEnergyConsumptionTrendFilterHash
      }
    default:
      return state;
  }
};

export default dashboardReducer;
